(() => {
  const EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new WeakMap();

  const durationFor = (distance) => Math.round(Math.min(620, Math.max(320, 260 + Math.abs(distance) * 0.9)));

  const measure = (details, open) => {
    const wasOpen = details.open;
    const inlineHeight = details.style.height;
    details.open = open;
    details.style.height = 'auto';
    const height = details.getBoundingClientRect().height;
    details.open = wasOpen;
    details.style.height = inlineHeight;
    return height;
  };

  const finish = (details, open) => {
    const current = running.get(details);
    if (current) {
      clearTimeout(current.fallback);
      current.height.onfinish = null;
      current.height.cancel();
      if (current.content) current.content.cancel();
    }
    details.open = open;
    details.classList.remove('is-closing', 'is-opening');
    details.style.height = '';
    details.style.overflow = '';
    running.delete(details);
  };

  const toggle = (details, summary) => {
    const current = running.get(details);
    const opening = current ? current.closing : !details.open;

    // Clip before measuring: the answer's bottom margin only counts inside the panel while it is clipped,
    // so measuring unclipped makes the page jump by that margin at the start and end of the animation.
    details.style.overflow = 'hidden';
    const startHeight = details.getBoundingClientRect().height;

    if (current) {
      clearTimeout(current.fallback);
      current.height.onfinish = null;
      current.height.cancel();
      if (current.content) current.content.cancel();
    }

    const endHeight = measure(details, opening);
    const duration = durationFor(endHeight - startHeight);

    details.style.height = `${startHeight}px`;
    details.open = true;
    details.classList.toggle('is-closing', !opening);
    details.classList.toggle('is-opening', opening);
    summary.setAttribute('aria-expanded', opening);

    const height = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration, easing: EASING }
    );

    const content = details.querySelector(':scope > .accordion__content');
    const contentAnimation = content
      ? content.animate(
          opening
            ? [{ opacity: 0, transform: 'translateY(-0.6rem)' }, { opacity: 1, transform: 'none' }]
            : [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-0.3rem)' }],
          { duration: opening ? duration : Math.round(duration * 0.55), easing: EASING, fill: 'both' }
        )
      : null;

    const state = { height, content: contentAnimation, closing: !opening, fallback: 0 };
    running.set(details, state);

    height.onfinish = () => {
      if (running.get(details) === state) finish(details, opening);
    };

    // Throttled or hidden tabs may never finish the animation; never leave a panel half-open.
    // Only force the end state once the animation has stopped advancing, so a busy page never snaps it shut early.
    let lastTime = -1;
    const watchdog = () => {
      if (running.get(details) !== state) return;
      const time = Number(height.currentTime) || 0;
      if (height.playState === 'running' && time > lastTime && time < duration) {
        lastTime = time;
        state.fallback = setTimeout(watchdog, 400);
        return;
      }
      finish(details, opening);
    };
    height.ready.then(() => {
      if (running.get(details) !== state) return;
      state.fallback = setTimeout(watchdog, duration + 400);
    });
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.accordion details > summary');
    if (!summary || reducedMotion.matches || typeof Element.prototype.animate !== 'function') return;
    if (document.body.classList.contains('rb-no-accordion-animation')) return;
    event.preventDefault();
    toggle(summary.parentElement, summary);
  });
})();
